import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface CardProps extends HTMLMotionProps<'div'> {
  children: React.ReactNode;
  hoverEffect?: boolean;
}
export function Card({
  children,
  className = '',
  hoverEffect = false,
  ...props
}: CardProps) {
  return <motion.div className={`bg-white rounded-2xl shadow-sm border border-neutral-100 overflow-hidden ${className}`} whileHover={hoverEffect ? {
    y: -5,
    boxShadow: '0 10px 30px -10px rgba(0,0,0,0.1)'
  } : undefined} transition={{
    duration: 0.2
  }} {...props} data-id="element-184">
      {children}
    </motion.div>;
}